export default "__VITE_ASSET__mKV7ZtS6__"